import React from 'react';
import {SENT_FAILURE, SENT_OK} from '../AskUsState'

const AskUs  = ({state, onAskUsChange, onValidateAskUsField, onSend, onResend, webFormRef, onHandleGdprCheck}) => {
    return (
        <section className="blue-dark">
            <div className = "box more-space" ref={webFormRef} >
                {state.sentStatus === SENT_OK ? 
                    (
                        <React.Fragment>
                            <div className = "col-center">
                                <h2>Váše předobjednávka byla úspěšně odeslána.<br/><span>Děkujeme za váš zájem!</span><br/><span>Budeme vás kontaktovat.</span></h2>
                            </div>
                            <div className = "col-center">
                                <button className='send-btn' onClick={onResend}>Poslat další dotaz</button>
                            </div>
                        </React.Fragment>
                    )
                        :
                    (
                        <React.Fragment>
                            {state.sentStatus === SENT_FAILURE && (
                                <div className = "col-center msgNok">
                                    <h3>Při registraci došlo k chybě, prosím zopakujte Váš požadavek za chvíli</h3>
                                </div>)
                            }

                            <div className = "col-2">
                                <div className = "form-desc">
                                    <p>V současné době přijímáme nezávazné předobjednávky. Pokud máte zájem o dárkové poukazy Mooveez, vyplňte prosím formulář.</p>
                                </div>
                            </div>

                            <div className="col-2">
                                <div className="form small texts-left">
                                <p>
                                    <input type="text"
                                    placeholder="*kontaktní osoba"
                                    value={state.name.value}
                                    onChange={e => onAskUsChange({name : { value : e.target.value}})}
                                    onBlur={e => onValidateAskUsField({name: e.target.value})}/><br/>

                                {state.name.errors !== undefined && state.name.errors.map((error) => <span>{error}</span>)}
                                </p>

                                <p>
                                    <input type="text"
                                    placeholder="*email"
                                    value={state.email.value}
                                    onChange={e => onAskUsChange({email: { value : e.target.value}})}
                                    onBlur={e => onValidateAskUsField({email: e.target.value})}/><br/>

                                {state.email.errors !== undefined && state.email.errors.map((error) => <span>{error}</span>)}
                                </p>

                                <p>
                                    <input type="text"
                                    placeholder="*telefon"
                                    value={state.phone.value}
                                    onChange={e => onAskUsChange({phone: { value : e.target.value}})}
                                    onBlur={e => onValidateAskUsField({phone: e.target.value})}/><br/>

                                {state.phone.errors !== undefined && state.phone.errors.map((error) => <span>{error}</span>)}
                                </p>

                                <p>
                                    <input type="text"
                                    value={state.company.value}
                                    placeholder="*název společnosti"
                                    onChange={e => onAskUsChange({company: { value : e.target.value}})}
                                    onBlur={e => onValidateAskUsField({company: e.target.value})}/><br/>

                                {state.company.errors !== undefined && state.company.errors.map((error) => <span>{error}</span>)}
                                </p>

                                <p>
                                    <input type="text"
                                    value={state.number.value}
                                    placeholder="*předpokládaný počet poukazů"
                                    onChange={e => onAskUsChange({number: { value : e.target.value}})}
                                    onBlur={e => onValidateAskUsField({number: e.target.value})}/><br/>

                                {state.number.errors !== undefined && state.number.errors.map((error) => <span>{error}</span>)}
                                </p>

                                <p>
                                    <textarea
                                    value={state.question.value}
                                    placeholder="váš vzkaz"
                                    onChange={e => onAskUsChange({question: { value : e.target.value}})}
                                    onBlur={e => onValidateAskUsField({question: e.target.value})}/>
                                    <br/>

                                {state.question.errors !== undefined && state.question.errors.map((error) => <span>{error}</span>)}
                                </p>
                                <p>
                                    <input type="checkbox"
                                    defaultChecked={state.gdprChecked.value}
                                    onChange={e => onHandleGdprCheck()}
                                    id="gdpr"
                                    className="checkbox-small"/>
                                    <label htmlFor="gdpr">*Souhlasím se zpracováním osobních údajů <a href="http://www.mooveez.com/cs/souhlas-a-pravidla-zpracovani-vasich-osobnich-udaju-ze-stranky-www-mooveez-com-81.html" target="_blank" rel="noopener noreferrer">(znění Souhlasu)</a></label>
                                    <br className="cl"/>
                                    {state.gdprChecked.errors !== undefined && state.gdprChecked.errors.map((error) => <span>{error}</span>)}
                                </p>
                                <p><span>* Povinné údaje</span></p>
                                <p>
                                    <button id='sendButton' className='send-btn' onClick={onSend}>Odeslat</button>
                                </p>
                                </div>
                            </div>
                        </React.Fragment>
                    )
                }



                <br className="cl"/>
                </div>
        </section>
    );
};

export default AskUs;


// WEBPACK FOOTER //
// ./src/components/company/askus/view/AskUs.jsx